import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Lock, CreditCard, Sparkles } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import usePublicPackages from '../hooks/usePublicPackages';

const API = process.env.REACT_APP_BACKEND_URL;

export const PaywallModal = ({ isOpen, onClose }) => {
  const [loading, setLoading] = React.useState(false);
  const { getPrice, getGrossPrice, getEmployeesPerLocation, loading: pkgsLoading } = usePublicPackages();

  const handleStartCheckout = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const frontendUrl = window.location.origin;
      
      const response = await axios.post(
        `${API}/api/payments/create-subscription-checkout`,
        { frontend_url: frontendUrl },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      
      // Redirect to Stripe Checkout
      window.location.href = response.data.url;
    } catch (error) {
      console.error('Error creating checkout:', error);
      toast.error('Fehler beim Starten des Checkouts');
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full">
              <Lock className="h-8 w-8 text-blue-600" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">
            Zahlung erforderlich
          </DialogTitle>
          <DialogDescription className="text-center space-y-3 pt-4">
            <p className="text-base">
              Bitte schließen Sie den Checkout-Prozess ab, um vollen Zugriff auf die App zu erhalten.
            </p>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
              <div className="flex items-center gap-2 text-blue-800 font-semibold mb-2">
                <Sparkles className="h-5 w-5" />
                <span>AllFlowX Billing V2</span>
              </div>
              {pkgsLoading ? (
                <p className="text-sm text-blue-600">Preise werden geladen...</p>
              ) : (
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>✅ Starter: {getPrice('starter') ? `${getPrice('starter').toFixed(2)} € Netto` : '29,90 € Netto'} / Monat <span className="text-xs text-muted-foreground">zzgl. MwSt.</span></li>
                  <li>✅ {getEmployeesPerLocation('starter')} Mitarbeiter inklusive pro Standort</li>
                  <li>✅ Monatlich kündbar · Keine Einrichtungsgebühr</li>
                </ul>
              )}
            </div>
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-3 mt-4">
          <Button
            onClick={handleStartCheckout}
            disabled={loading}
            className="w-full h-12 text-base"
            size="lg"
          >
            {loading ? (
              'Checkout wird vorbereitet...'
            ) : (
              <>
                <CreditCard className="mr-2 h-5 w-5" />
                Abonnement jetzt starten
              </>
            )}
          </Button>
          
          <Button
            variant="ghost"
            onClick={onClose}
            disabled={loading}
            className="w-full"
          >
            Später
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
